__turbopack_context__.v({
  "body": "_4UzvAa_body",
  "container": "_4UzvAa_container",
  "header": "_4UzvAa_header",
  "heading": "_4UzvAa_heading",
  "icon": "_4UzvAa_icon",
  "item": "_4UzvAa_item",
  "list": "_4UzvAa_list",
  "root": "_4UzvAa_root",
  "title": "_4UzvAa_title",
});
